/* -disable no-useless-constructor */
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';
import { BodyRow } from './styles';
// Third Party Components

export default class TBody extends Component {
  constructor(props) {
    super(props);
  }

  _renderCellAlignmentClass(cellIndex) {
    switch (this.props.headers[cellIndex].alignment) {
      case 'right':
        return 'Table__cell--align-right';

      case 'center':
        return 'Table__cell--align-center';

      default:
        return '';
    }
  }

  _renderCellHighlightClass(cellIndex) {
    if (this.props.headers[cellIndex].highlighted) {
      return 'Table__cell--highlighted';
    }
    return '';
  }

  _renderTableRows(rows) {
    const { hasHover, renderRowRight, activeRow, isActive } = this.props;
    return rows.map((row, rowIndex) => {
      const cells = Object.keys(row).map((cell, index) => (
        <td
          // -disable-next-line react/no-array-index-key
          key={index}
          title={row[cell]}
          className={`Table__cell ${this._renderCellAlignmentClass(
            index,
          )} ${this._renderCellHighlightClass(index)} ${
            this.props.wrapCells && 'Table__cell-wrap'
          }`}
        >
          {this.props.headers[index].format === 'currency' ? (
            <FormattedNumber
              // -disable-next-line react/style-prop-object
              style="decimal"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={row[cell]}
            />
          ) : (
            row[cell]
          )}
        </td>
      ));

      return (
        <BodyRow
          hasHover={hasHover}
          active={
            isActive &&
            activeRow &&
            JSON.stringify(row) === JSON.stringify(activeRow)
          }
          // -disable-next-line react/no-array-index-key
          key={rowIndex}
          onClick={() => this.props.onRowClick(cells, row)}
          className="Table__row"
        >
          {cells}
          {renderRowRight &&
            renderRowRight(
              isActive && JSON.stringify(row) === JSON.stringify(activeRow),
            )}
        </BodyRow>
      );
    });
  }

  render() {
    return (
      <tbody className="Table__tbody">
        {this._renderTableRows(this.props.rows)}
      </tbody>
    );
  }
}
